import { toast, ToastContainer } from 'react-toastify';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaRegDotCircle } from 'react-icons/fa';

const showToast = (type, message) => {
  switch (type) {
    case 'success':
      toast.success(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white", // Light green background
          color: '#0020BD', // Blue text color
          borderRadius: '8px',
          padding: '10px',
          fontFamily: 'Inter',
        },
        progressClassName: 'bg-[#0020BD]', // Set progress bar to blue
        toastClassName: 'border-l-4 border-[#0020BD] shadow-lg', // Optional border and shadow
        icon: <FaCheckCircle size={20} className="text-[#0020BD]" />, // Custom icon color
      });
      break;
    case 'error':
      toast.error(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white", // Light red background
          color: '#DA1A28', // Red text color
          borderRadius: '8px',
          padding: '10px',
          fontFamily: 'Inter',
        },
        progressClassName: 'bg-[#DA1A28]', // Set progress bar to blue
        toastClassName: 'border-l-4 border-[#DA1A28] shadow-lg', // Optional border and shadow
        icon: <FaExclamationCircle size={20} className="text-[#DA1A28]" />, // Custom icon color
      });
      break;
    case 'info':
      toast.info(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white", // Light blue background
          color: '#0020BD', // Blue text color
          borderRadius: '8px',
          padding: '10px',
        },
        progressClassName: 'bg-[#0020BD]', // Set progress bar to blue
        toastClassName: 'border-l-4 border-[#0020BD] shadow-lg', // Optional border and shadow
        icon: <FaInfoCircle size={20} className="text-[#0020BD]" />, // Custom icon color
      });
      break;
    case 'warning':
      toast.warning(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white", // Light yellow background
          color: '#DA1A28', // Red text color
          borderRadius: '8px',
          padding: '10px',
        },
        progressClassName: 'bg-[#DA1A28]', // Set progress bar to blue
        toastClassName: 'border-l-4 border-[#DA1A28] shadow-lg', // Optional border and shadow
        icon: <FaRegDotCircle size={20} className="text-[#DA1A28]" />, // Custom icon color
      });
      break;
    default:
      toast(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white",
          color: "#060073", // Default text color
          borderRadius: '8px',
          padding: '10px',
        },
        progressClassName: 'bg-[#0020BD]', // Set progress bar to blue

        toastClassName: 'border-l-4 border-[#060073] shadow-lg', // Optional border and shadow
        icon: <FaInfoCircle size={20} className="text-[#060073]" />, // Custom icon color
      });
      break;
  }
};

export default showToast;
